/* eslint react/jsx-indent: 0 */
/* Need to leave this in place because Prettier keeps borking the indentation on commit */

import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';
import { Common } from 'ws-scripts/modules/common';
import { IncentiveModal } from 'wsm-incentive-modal';
import { filterSummary, filterLoanLease } from '../utils/utility';
import PricingDetail from '../components/PricingDetail';
import PricingLoanLease from '../components/PricingLoanLease';
import PricingSummaryContainer from '../components/PricingSummaryContainer';
import InstantEPrice from '../containers/InstantEPrice';
import { PaymentCalculatorButton } from '../components/PaymentCalculatorButton';
import { EPRICE_PENDING } from '../constants/labels';

import '../global-sass/main.scss';

export class WidgetContainer extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			incentive: {},
			isModalVisible: false,
			isDisplayingEprice: false,
			isScrollingSidebar: false
		};
		this.showEPrice = this.showEPrice.bind(this);
		this.trackScrollingSidebar = this.trackScrollingSidebar.bind(this);
		this.showModal = this.showModal.bind(this);
		this.hideModal = this.hideModal.bind(this);
	}

	componentDidMount() {
		if (this.props.deviceType === 'DESKTOP') {
			window.addEventListener('scroll', this.trackScrollingSidebar);
		}
	}

	componentWillUnmount() {
		if (this.props.deviceType === 'DESKTOP') {
			window.removeEventListener('scroll', this.trackScrollingSidebar);
		}
	}

	showModal(incentive) {
		this.setState({
			incentive,
			isModalVisible: true
		});
	}

	hideModal() {
		// deliberately do not reset the incentive so that
		// that data doesn't disappear as it slides off the screen,
		// esp. for mobile modal
		this.setState({
			isModalVisible: false
		});
	}

	showEPrice() {
		this.setState({
			isDisplayingEprice: true
		});
	}

	trackScrollingSidebar() {
		// Tracks whether the sidebar is scrolling or not based on the height set
		this.setState({
			isScrollingSidebar:
				document.querySelector('.vdp-sidebar').style.top.length > 0
		});
	}

	render() {
		const {
			pricing,
			widgetInfo = { windowId: '' },
			incentiveData,
			windowId,
			widgetName,
			deviceType,
			locale,
			dealerAddress,
			account = { name: '' }
		} = this.props;

		const { accountId, vehicleAccountId, vehicleType } = widgetInfo;
		const isMobile = deviceType === 'MOBILE';
		let rootComponent;

		if (pricing) {
			const { ePriceStatus } = pricing;
			let disableInstantEpriceButton = false;
			// {epriceStatus : { status : <<enum>> }} where <<enum>> is one of the values below
			// ENABLED -> E-price is enabled/avaialble for the account, uuid combination.
			// DISABLED -> E-price is disabled/not available for the account, uuid combination. Reason for non availabilty is given in the reason string
			// NON_APPLICABLE -> E-price is not applicable for the account and uuid combination.
			if (ePriceStatus && ePriceStatus === 'DISABLED') {
				disableInstantEpriceButton = true;
			}
			// TODO: remove after VCDA release
			else if (!ePriceStatus && pricing.summary) {
				const eprice = pricing.summary.filter(
					x => x.priceType === 'EPRICE'
				)[0];
				const dprice = pricing.summary.filter(
					x => x.priceType === 'DPRICE'
				)[0];
				if (eprice && dprice) {
					disableInstantEpriceButton = !(eprice.value < dprice.value);
				}
			}
			const detailType =
				pricing.detail.ePrice && this.state.isDisplayingEprice
					? 'ePrice'
					: 'dPrice';

			const summary = filterSummary(pricing.summary, detailType);
			const loanLeaseSummary = filterLoanLease(pricing.summary);
			let incentiveModal;

			if (Object.keys(incentiveData).length) {
				incentiveModal = (
					<Common
						render={({ prefs, sitemap }) => {
							return (
								<IncentiveModal
									incentive={this.state.incentive}
									isOpen={this.state.isModalVisible}
									isMobile={isMobile}
									onModalClose={this.hideModal}
									widgetInfo={{
										windowId,
										widgetName,
										deviceType
									}}
									account={{
										name: account.name,
										id: account.id
									}}
									newListingPath={sitemap.get(
										'INVENTORY_LISTING_DEFAULT_AUTO_NEW'
									)}
									usedListingPath={sitemap.get(
										'INVENTORY_LISTING_DEFAULT_AUTO_USED'
									)}
									// remove locale when when <Common /> is added to module
									locale={locale}
									prefs={prefs}
								/>
							);
						}}
					/>
				);
			}

			rootComponent = (
				<Common
					render={({ flags, prefs, labels }) => {
						const ePricePendingLabel = labels.get(EPRICE_PENDING);
						const buttonMobileClass =
							prefs.showLoanLeasePricing === 'true'
								? 'mb-4'
								: 'mb-0';
						const instantEpricePreventMultipleEpriceLeads =
							prefs.instantEpricePreventMultipleEpriceLeads ===
							'true';
						const instantEPriceContainer =
							(pricing.detail.ePrice || // TODO: remove once vcda flag for epricestatus is removed
								// and undefined ePriceStatus may denote that IEP is enabled but not configured
								// this check is the one place we can prevent the unconfigured IEP button from showing
								(ePriceStatus &&
									ePriceStatus !== 'NON_APPLICABLE')) &&
							// compare request account and vehicle account equality to determine
							// whether a vehicle is off-site
							(prefs.showInstantEpriceForSharedInventory !==
								'false' ||
								accountId === vehicleAccountId) ? (
								<InstantEPrice
									showEPrice={this.showEPrice}
									isDisplayingEprice={
										this.state.isDisplayingEprice
									}
									instantEpriceShowAllAfterLeadSubmit={
										prefs.instantEpriceShowAllAfterLeadSubmit
									}
									ePriceDetail={pricing.detail.ePrice}
									buttonLabel={pricing.ePriceButtonLabel}
									pendingLabel={ePricePendingLabel}
									widgetInfo={{
										...widgetInfo,
										windowId,
										widgetName
									}}
									buttonStyle={prefs.buttonStyleEPrice}
									buttonMobileClass={buttonMobileClass}
									preventMultipleEpriceLeads={
										instantEpricePreventMultipleEpriceLeads
									}
									isMobile={isMobile}
									disabled={disableInstantEpriceButton}
								/>
							) : null;

						const isFinalPriceFlagEnabled =
							flags[
								'ws-detailed-pricing.use-final-price-for-instant-eprice'
							] === true;

						const DDCExists =
							typeof window !== 'undefined' &&
							typeof window.DDC !== 'undefined';

						let drEnable = false;
						/* eslint no-undef: 0 */
						if (DDCExists && DDC.getSiteProperty) {
							drEnable = DDC.getSiteProperty(
								prefs.paymentCalculatorButtonDisplayCondition
							);
						}
						return (
							<div>
								<PricingDetail
									detail={pricing.detail[detailType]}
									detailType={detailType}
									widgetInfo={{
										windowId,
										widgetName,
										deviceType,
										vehicleType
									}}
									prefs={prefs}
									showModal={this.showModal}
									incentiveData={incentiveData}
									locale={locale}
									dealerAddress={dealerAddress}
									isFinalPriceFlagEnabled={
										isFinalPriceFlagEnabled
									}
								/>
								<PricingSummaryContainer
									summary={summary}
									prefs={prefs}
									dealerAddress={dealerAddress}
									widgetInfo={{
										windowId,
										widgetName,
										deviceType
									}}
								/>
								{instantEPriceContainer}
								{/* Remove showLoanLeasePricing once the summary undergoes IDC treatment */}
								{loanLeaseSummary.length > 0 &&
									prefs.showLoanLeasePricing === 'true' && (
										<PricingLoanLease
											summary={loanLeaseSummary}
											isMobile={isMobile}
											isScrollingSidebar={
												this.state.isScrollingSidebar
											}
										/>
									)}
								{drEnable && (
									<PaymentCalculatorButton
										isLoanLeaseAvailable={
											loanLeaseSummary.length > 0 &&
											prefs.showLoanLeasePricing ===
												'true'
										}
										isScrollingSidebar={
											this.state.isScrollingSidebar
										}
										isMobile={isMobile}
										prefs={prefs}
										labels={labels}
									/>
								)}
								{incentiveModal}
							</div>
						);
					}}
				/> // Common
			);
		}
		return rootComponent;
	}
}

WidgetContainer.propTypes = {
	pricing: PropTypes.shape({
		detail: PropTypes.shape({
			dPrice: PropTypes.arrayOf(
				PropTypes.shape({
					_type: PropTypes.string.isRequired,
					formatted: PropTypes.string.isRequired,
					label: PropTypes.string.isRequired,
					value: PropTypes.number.isRequired,
					incentives: PropTypes.arrayOf(PropTypes.string)
				})
			).isRequired,
			ePrice: PropTypes.arrayOf(
				PropTypes.shape({
					_type: PropTypes.string.isRequired,
					formatted: PropTypes.string.isRequired,
					label: PropTypes.string.isRequired,
					value: PropTypes.number.isRequired,
					incentives: PropTypes.arrayOf(PropTypes.string)
				})
			)
		}),
		summary: PropTypes.arrayOf(
			PropTypes.shape({
				_type: PropTypes.string.isRequired,
				formatted: PropTypes.string.isRequired,
				label: PropTypes.string.isRequired,
				value: PropTypes.number.isRequired
			})
		),
		ePriceButtonLabel: PropTypes.string.isRequired,
		ePriceStatus: PropTypes.string
	}),
	incentiveData: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.string,
			title: PropTypes.string,
			shortTitle: PropTypes.string,
			label: PropTypes.string,
			offerDetails: PropTypes.string,
			effectiveDate: PropTypes.string,
			expirationDate: PropTypes.string,
			conditional: PropTypes.bool,
			disclaimer: PropTypes.string,
			make: PropTypes.string,
			condition: PropTypes.string,
			manufacturerOffer: PropTypes.bool,
			specific: PropTypes.object,
			error: PropTypes.string
		}).isRequired
	).isRequired,
	widgetInfo: PropTypes.shape({
		vehicleId: PropTypes.string.isRequired,
		vehicleCategory: PropTypes.string.isRequired,
		vehicleType: PropTypes.string.isRequired,
		pageAlias: PropTypes.string.isRequired,
		accountId: PropTypes.string.isRequired,
		vehicleAccountId: PropTypes.string.isRequired
	}).isRequired,
	windowId: PropTypes.string.isRequired,
	widgetName: PropTypes.string.isRequired,
	deviceType: PropTypes.string.isRequired,
	locale: PropTypes.string,
	dealerAddress: PropTypes.shape({
		address1: PropTypes.string,
		address2: PropTypes.string,
		address3: PropTypes.string,
		city: PropTypes.string,
		state: PropTypes.string,
		postalCode: PropTypes.string,
		country: PropTypes.string
	}),
	account: PropTypes.shape({
		name: PropTypes.string,
		id: PropTypes.string
	}).isRequired
};

WidgetContainer.defaultProps = {
	pricing: [],
	locale: 'en_US',
	dealerAddress: {}
};

const mapStateToProps = state => {
	return {
		pricing: state.pricing,
		widgetInfo: state.widgetInfo,
		incentiveData: state.incentive.incentiveData,
		windowId: state.requestData.windowId,
		widgetName: state.requestData.widgetName,
		deviceType: state.requestData.deviceType,
		locale: state.requestData.locale,
		dealerAddress: state.dealerAddress,
		account: state.account
	};
};

const mapDispatchToProps = _dispatch => ({});

const Widget = connect(
	mapStateToProps,
	mapDispatchToProps
)(WidgetContainer);

export default Widget;



// WEBPACK FOOTER //
// ./src/containers/Widget.jsx